export default function headerDropNavigation() {  
  document.querySelectorAll('.header__item').forEach(item => {
    const navLink = item
    const subBlock = item.querySelector('.header__sub-list')

    if (navLink && subBlock) {
      navLink.addEventListener('mouseenter', () => {
        subBlock.classList.add('-is-hover')
      })

      navLink.addEventListener('mouseleave', (event) => {
        const toElement = event.relatedTarget
        if (!subBlock.contains(toElement)) {
          setTimeout(() => {
            if (!subBlock.matches(':hover')) {
              subBlock.classList.remove('-is-hover')
            }
          }, 150) // 小さな遅延を設定して、マウスがfooter__sub-blockに移動する間に-is-hoverが取れないようにする
        }
      })

      subBlock.addEventListener('mouseleave', () => {
        subBlock.classList.remove('-is-hover')
      })
    }
  })
}
